import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=774a4c86&scoped=true&"
import script from "./Instruments.vue?vue&type=script&lang=js&"
export * from "./Instruments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a4c86",
  null
  
)

export default component.exports